
import { faCar, faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { mapGetters } from 'vuex'

export default {
  name: 'BookingRunningNowBanner',

  data() {
    return {
      hasTimeLeft: true,
      timeRemaining: 0,
      percentageComplete: 0,
      faChevronRight,
      faCar
    }
  },

  computed: {
    ...mapGetters({
      bookingRunningNow: 'booking/bookingRunningNow'
    })
  },

  watch: {
    bookingRunningNow(newValue, oldValue) {
      const newId = newValue?.id
      const oldId = oldValue?.id

      if (newId !== oldId) {
        this.$log.debug('BookingRunningNowBanner: bookingRunningNow changed, updating live activity')
        this.startLiveActivity()
      }
    }
  },

  mounted() {
    this.updateTimeRemaining()
    this.interval = setInterval(this.updateTimeRemaining, 1000)

    this.startLiveActivity()
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  methods: {
    startLiveActivity() {
      if (
        !this.$app.isNative ||
        this.$app.platform !== 'ios' ||
        !this.$liveActivity?.isAvailable ||
        !this.bookingRunningNow?.id ||
        this.$dateNew.fromSQL(this.bookingRunningNow.endAt).plus({ minutes: 10 }) <= this.$dateNew.now()
      ) {
        return
      }

      this.$liveActivity.start({
        bookingId: this.bookingRunningNow?.id,
        startAt: this.bookingRunningNow.startAt,
        endAt: this.bookingRunningNow.endAt,
        paddockName: this.bookingRunningNow.paddock.name
      })
    },

    updateTimeRemaining() {
      if (!this.bookingRunningNow) {
        this.hasTimeLeft = false
        this.timeRemaining = 0
        return
      }

      const endAt = this.$dateNew.fromSQL(this.bookingRunningNow.endAt)
      const diff = endAt.diff(this.$dateNew.now(), ['minutes', 'seconds']).toObject()

      const minutes = diff.minutes ? String(Math.floor(diff.minutes)).padStart(2, '0') : '00'
      const seconds = diff.seconds ? String(Math.floor(diff.seconds)).padStart(2, '0') : '00'

      this.timeRemaining = `${minutes}:${seconds}`

      if (this.$dateNew.now() > endAt) {
        this.hasTimeLeft = false
        this.timeRemaining = '00:00'
        clearInterval(this.interval)
        return
      }

      // Calculate percentage complete
      const startAt = this.$dateNew.fromSQL(this.bookingRunningNow.startAt)
      const totalDuration = endAt.diff(startAt).as('seconds')
      const elapsedDuration = this.$dateNew.now().diff(startAt).as('seconds')

      this.percentageComplete = Math.min((elapsedDuration / totalDuration) * 100, 100)
    }
  }
}
